﻿import $ from 'jquery';
import { ErrorPopover } from "../../utilities/formvalidation/errorpopover";

declare global {
  interface JQuery {
    editortable_validation(): JQuery;
  }
}

export class Validation {
  static wireup: string = ".editortable-validation";
  constructor(private $element: JQuery) {
    this.init();
  }
  private init(): void {
    this.$element.each(function () {
      if (!$(this).is(".editortable-validation"))
        throw new Error("editor table validation root must be marked with .editortable-validation");

      $(this).find("span").each(function () {
        let $el = $(this);
        let key = $el.attr("title");
        let tableKey = $el.data("key");
        let matchIndex = key.match(/.*\[(\d+)\].*/);
        if (!matchIndex)
          return;
        let rowNum = parseInt(matchIndex[1]);
        let lastDot = key.lastIndexOf(".");
        let columnName = key.substring(lastDot + 1, key.length);

        let table = $("[data-et-key='" + tableKey + "']");
        let row = table.find("tbody tr").eq(rowNum);
        let inputCell = row.find(":input[name$='." + columnName + "']");
        let displayCell = row.find(`[data-et-validation='${columnName}']`)
        let cell = inputCell.length !== 0 ? inputCell : displayCell;
        if (cell.length == 0)
          console.error(`Unable to find column for validation, looking for column name that ends with: ${columnName} or data-et-validation='${columnName}'`);

        new EditorTableErrorPopover({
          sizing: cell.data('sizing')
        }).append(cell, columnName + rowNum, $el.text());

      });
    });
  }
}

export class EditorTableErrorPopover extends ErrorPopover {
  constructor(popoverOptions) {
    super(popoverOptions);
  }
  public append($target: JQuery, targetId: string, message, trigger?: string): void {
    super.append($target, targetId, message, $target.is("td") ? "click" : undefined);
  }

  protected addValidationClass($target: JQuery) {
    if ($target.is("td"))
      super.addValidationClass($target);
    else
      super.addValidationClass($target.parents("td"));
  }
}

($ => {
  function Plugin() {
    return this.each(function () {
      new Validation($(this));
    });
  }
  $.fn.editortable_validation = Plugin;

})($);
